export default "__VITE_ASSET__DIFoG6Tv__"